import React from 'react'
import ApiDoc from '../../apidoc'
import api from '../../../../../../api-server/dist/openapi/v0/oauth.json';

export default props => <ApiDoc spec={api} {...props} />
